import AdminIndex from "./AdminIndex";
import ManageSubjects from "./ManageSubjects";

const adminRoutes = [
  {
    index: true,
    element: <AdminIndex />,
  },
  { 
    path: "subjects",
    element: <ManageSubjects />,
  }
];

export default adminRoutes;